<template>
  <a-config-provider :locale="locale" :getPopupContainer="getPopupContainer">
    <div id="app">
      <router-view></router-view>
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { AppDeviceEnquire } from '@/utils/mixin'
export default {
  mixins: [AppDeviceEnquire],
  data() {
    return {
      locale: zhCN,
    }
  },
  mounted() {},
  methods: {
    getPopupContainer(triggerNode, dialogContext) {
      return triggerNode ? triggerNode.parentNode : document.body
    },
  },
}
</script>
<style lang="less"></style>
